module.exports = __webpack_public_path__ + "static/img/bg-three.cfcd454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-three.png
// module id = Sm5g
// module chunks = 1